import { render, staticRenderFns } from "./voucher.vue?vue&type=template&id=95a3c42a"
import script from "./voucher.vue?vue&type=script&lang=js"
export * from "./voucher.vue?vue&type=script&lang=js"
import style0 from "./voucher.vue?vue&type=style&index=0&id=95a3c42a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports